angular.module('Itao.IndicatorMap').directive('indicatorSelectedIndicators', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'selectedIndicators.html',
    restrict: 'E',
    scope: {
      selectedIndicators: '=',
      onIndicatorDeselect: '&',
      setSelectedIndicator: '&',
      selectedDataLayer: '=',
      poiLayerTypes: '=',
      selectPoiIndicator: '&'
    },
    link: function (scope) {
      var insertedAt;
      scope.chartColorAt = mapConfig.chartColorAt;

      scope.indicatorInserted = function (index) {
        insertedAt = index;
      };

      /**
       * Reorder the selectedIndicators in the globalScope and selects the first
       * @param {Event} event move event
       * @param {Integer} index index
       */
      scope.indicatorMoved = function (event, index) {
        // Have to do that workaround, because the copied Object from "angular-drag-and-drop-lists"
        // is just a normal object - not an Indicator with its prototype-functions
        // ToDo: There is a unsexy effect caused of this workaround when you drop an item
        scope.selectedIndicators[insertedAt] = scope.selectedIndicators[index];
        scope.selectedIndicators.splice(index, 1);
        scope.setSelectedIndicator();
      };

      scope.$watch('selectedDataLayer', function (selectedDataLayer) {
        if(angular.isArray(scope.selectedIndicators)) {
          if(angular.isObject(selectedDataLayer)) {
            // remove unavailable indicators
            for(var i = 0; i < scope.selectedIndicators.length; i++) {
              if(selectedDataLayer.indicators.indexOf(scope.selectedIndicators[i].uid) === -1) {
                scope.selectedIndicators.splice(i, 1);
              }
            }
          } else {
            scope.selectedIndicators.splice(0, scope.selectedIndicators.length);
          }
        }
      });
    }
  };
});
